import clsx from 'clsx';
import {
  Field,
  Input as HeadlessUIInput,
  InputProps as HeadlessUIInputProps,
  Label,
} from '@headlessui/react';

export type InlineCheckOrRadioProps = {
  label: React.ReactNode;
  type: Extract<HeadlessUIInputProps['type'], 'checkbox' | 'radio'>;
} & Omit<HeadlessUIInputProps, 'type' | 'className' | 'id' | 'style'>;

export const InlineCheckOrRadio = ({
  label,
  ...rest
}: InlineCheckOrRadioProps) => {
  const { type } = rest;

  return (
    <Field className="flex items-center gap-x-4">
      <HeadlessUIInput
        {...rest}
        className={clsx(
          'size-4 cursor-pointer',
          type === 'checkbox' && 'rounded',
        )}
      />

      <Label className="cursor-pointer">{label}</Label>
    </Field>
  );
};
